
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeSavedAmount1() {
                    var savedAmount = Math.round((this.compare_at_price - this.price) * 100 / this.compare_at_price);
                    return [savedAmount >= 5 ? _createElement('span', {
                            'className': 'badge badge--onsale flex items-center gap-1d5 font-medium leading-none rounded-full',
                            'key': '4031'
                        }, '\n          ', savedAmount, '%\n        ') : null];
                }
                function scopeImage2(i, iIndex) {
                    var image = `image${ i == 1 ? '' : i }`;
                    return [this[image] ? _createElement('div', {
                            'key': image,
                            'className': 'media media--height media--contain w-full h-full overflow-hidden'
                        }, _createElement('img', {
                            'className': 'media media--height media--contain w-full h-full overflow-hidden',
                            'src': this.resizeImage(this[image]),
                            'alt': this.removeHTML(this.title),
                            'key': image,
                            'width': '800',
                            'height': '600',
                            'loading': 'lazy',
                            'is': 'lazy-image'
                        })) : null];
                }
                function repeatI3(i, iIndex, image) {
                    return scopeImage2.apply(this, [
                        i,
                        iIndex
                    ]);
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI5(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return showUniversal && this.Fitment === 'Universal Fit' || !showUniversal && this.Fitment !== 'Universal Fit' ? _createElement('div', {
                    'className': 'card product-card product-card--standard flex flex-col leading-none relative overflow-hidden',
                    'key': '0'
                }, _createElement('div', { 'className': 'product-card__media relative h-auto' }, this.on_sale ? _createElement('div', {
                    'className': 'badges z-2 absolute grid gap-3 pointer-events-none',
                    'key': '311'
                }, scopeSavedAmount1.apply(this, [])) : null, _createElement('a', {
                    'className': 'block relative media media--square media--contain' + (this.image2 ? '' : ' overflow-hidden'),
                    'href': this.url,
                    'aria-label': this.removeHTML(this.title),
                    'tabIndex': '-1'
                }, this.image2 ? _createElement.apply(this, [
                    'div',
                    { 'key': '936' },
                    _map([
                        1,
                        2,
                        3,
                        4
                    ], repeatI3.bind(this))
                ]) : null, this.image2 ? _createElement('convermax-secondary-media', {
                    'key': '1492',
                    'class': 'product-card__carousel block absolute top-0 left-0 w-full h-full hidden md:block flickity-enabled'
                }) : null, _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'width': '800',
                    'height': '600',
                    'loading': 'lazy',
                    'is': 'lazy-image'
                }))), _createElement('div', { 'className': 'product-card__content grow flex flex-col justify-start text-center' }, _createElement('div', { 'className': 'product-card__top w-full' }, _createElement('span', { 'className': 'sr-only' }, 'Vendor:'), _createElement('a', mergeProps({
                    'className': 'caption reversed-link uppercase leading-none tracking-widest',
                    'href': this.vendor_url,
                    'title': 'this.removeHTML(this.vendor)'
                }, { dangerouslySetInnerHTML: { __html: this.vendor } }))), _createElement('div', {
                    'className': 'product-card__details flex flex-col lg:flex-row items-baseline gap-2 w-full',
                    'data-regios-dopp-generic-product-id': this.id
                }, _createElement('p', { 'className': 'grow' }, _createElement('a', mergeProps({
                    'className': 'product-card__title reversed-link text-base-xl font-medium leading-tight',
                    'href': this.url
                }, { dangerouslySetInnerHTML: { __html: this.title } }))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '25880'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI5.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'price flex flex-wrap lg:flex-col lg:items-end gap-2 md:gap-1d5' + (this.on_sale ? ' price--on-sale' : '') + ' regios-dopp-generic-price-container' }, this.price_varies ? _createElement('span', { 'key': '3171' }, 'From: ') : null, _createElement('span', { 'className': 'price__sale inline-flex items-center h-auto relative regios-dopp-generic-price-item--regular' }, '\n          ', this.formatPrice(this.compare_at_price), '\n        '), _createElement('span', { 'className': 'price__regular whitespace-nowrap regios-dopp-generic-price-item--sale' }, '\n          ', this.formatPrice(this.price), '\n        '))))) : null;
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []